var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShirt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.7358 4C19.8064 5.34883 20.372 6.55557 21.2675 7.45449C22.2275 8.41123 23.5381 8.99951 24.9998 8.99951C26.4615 8.99951 27.772 8.41113 28.7315 7.45449C29.6277 6.55557 30.1932 5.34893 30.2638 4H19.7358Z",
    opacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.7958 11.5647C42.5486 7.15461 37.9468 4.44912 33.0005 4.63005C32.5487 8.65115 29.1416 11.7767 24.9999 11.7778C20.8582 11.7767 17.4511 8.65115 16.9993 4.63005C12.0531 4.44912 7.4512 7.15463 5.20407 11.5647L0 21.7778L7.77773 27.3334L9.44443 25.1111V45.1111H40.5555V25.1111L42.2222 27.3334L50 21.7778L44.7958 11.5647Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShirt);
export default __webpack_public_path__ + "static/media/shirt.59e9255eb74646754655b6cc54460d2c.svg";
export { ForwardRef as ReactComponent };